"use client";

import { XMarkIcon } from "@heroicons/react/24/outline";

import { SmallTitle } from "@/components/text/SmallTitle";
import { IsolationConstructedNoDates } from "@/types/types";

export function FailedIsolation({
  isolation,
}: {
  isolation: IsolationConstructedNoDates;
}) {
  return (
    <div className="mb-4 sm:flex sm:items-start">
      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
        <XMarkIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
      </div>
      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
        <SmallTitle elementType="p">
          {isolation.failedMessage === null ?
            "Something went wrong"
          : isolation.failedMessage}
        </SmallTitle>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            The conversion time has been returned. Please try again!
          </p>
        </div>
      </div>
    </div>
  );
}
